import React, { useContext, useState, useEffect } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { Foods } from "../ModalIntegranteParts/Foods";
import { Form } from "../ModalIntegranteParts/Form";
import { Cleaning } from "../ModalIntegranteParts/Cleaning";
import { addRoutine, editRoutine, getMenu } from "../../api/autenticoAPI";
import { Textarea } from "@mui/joy";
import { CustomAlert } from "../CustomAlert/CustomAlert";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NotesIcon from "@mui/icons-material/Notes";
import {
  AreaText,
  CardsArea,
} from "../IntegranteItem/styles";

// TabPanel removido - não utilizado

export const IntegranteForm = ({ student, status, date, editData, onSave, onClose, onSaveClick }) => {
  const { user } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(0);
  const [menu, setMenu] = useState({ breakfast: [], lunch: [], snack: [] });
  const [showMessage, setShowMessage] = useState(false);
  const [infoMessage, setInfoMessage] = useState("");
  const [infoType, setInfoType] = useState("success");

  // Estados do formulário
  const [entryHours, setEntryHours] = useState(status && editData?.sleep ? editData.sleep.entryHours : 11);
  const [entryMinutes, setEntryMinutes] = useState(status && editData?.sleep ? editData.sleep.entryMinutes : 30);
  const [exitHours, setExitHours] = useState(status && editData?.sleep ? editData.sleep.exitHours : 12);
  const [exitMinutes, setExitMinutes] = useState(status && editData?.sleep ? editData.sleep.exitMinutes : 30);
  const [breakfast, setBreakfast] = useState(status && editData?.breakfast ? editData.breakfast.foods : []);
  const [qtdBreakfast, setQtdBreakfast] = useState(status && editData?.breakfast ? editData.breakfast.quantity : false);
  const [unavaibleBreakfast, setUnavailableBreakfast] = useState(status && editData?.breakfast ? editData.breakfast.unavailable : true);
  const [lunch, setLunch] = useState(status && editData?.lunch ? editData.lunch.foods : []);
  const [qtdLunch, setQtdLunch] = useState(status && editData?.lunch ? editData.lunch.quantity : false);
  const [unavailableLunch, setUnavailableLunch] = useState(status && editData?.lunch ? editData.lunch.unavailable : true);
  const [snack, setSnack] = useState(status && editData?.snack ? editData.snack.foods : []);
  const [qtdSnack, setQtdSnack] = useState(status && editData?.snack ? editData.snack.quantity : false);
  const [unavaibleSnack, setUnavailableSnack] = useState(status && editData?.snack ? editData.snack.unavailable : true);
  const [morningUniform, setMorningUniform] = useState(status && editData?.full_uniform ? editData.full_uniform.morning : "positive");
  const [lateUniform, setLateUniform] = useState(status && editData?.full_uniform ? editData.full_uniform.afternoon : "positive");
  const [tomouBanho, setTomouBanho] = useState(status && editData?.cleaning ? editData.cleaning.shower : "negative");
  const [lavouCabeca, setLavouCabeca] = useState(status && editData?.cleaning ? editData.cleaning.wash_head : "negative");
  const [materialPessoal, setMaterialPessoal] = useState(status && editData?.cleaning ? editData.cleaning.supplies : "positive");
  const [infoFamilia, setInfoFamilia] = useState(status && editData?.cleaning ? editData.cleaning.info_family : "negative");
  const [courseware, setCourseware] = useState(status && editData?.courseware ? editData.courseware.full : "positive");
  const [homeWork, setHomeWork] = useState(status && editData?.courseware ? editData.courseware.home_work : "positive");
  const [arrivalTime, setArrivalTime] = useState(status && editData?.sleep ? editData.sleep.arrive_on_time : "positive");
  const [sleptSchool, setSleptSchool] = useState(status && editData?.sleep ? editData.sleep.sleep_at_school : "negative");
  const [pee, setPee] = useState(status && editData?.cleaning ? editData.cleaning.pee : []);
  const [evacuate, setEvacuate] = useState(status && editData?.cleaning ? editData.cleaning.evacuate : []);
  const [fraud, setFraud] = useState(status && editData?.cleaning ? editData.cleaning.fraud : []);
  const [generalComments, setGeneralComments] = useState(status && editData ? editData.general_comments : "");

  useEffect(() => {
    const loadMenuItems = async () => {
      if (user?.unit) {
        try {
          const menuData = await getMenu(user.unit);
          // Garantir ordenação alfabética em cada categoria
          const sortedMenu = {
            breakfast: [...menuData.breakfast].sort((a, b) => 
              a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
            ),
            lunch: [...menuData.lunch].sort((a, b) => 
              a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
            ),
            snack: [...menuData.snack].sort((a, b) => 
              a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
            ),
          };
          setMenu(sortedMenu);
        } catch (error) {
          console.error("Erro ao carregar itens do cardápio:", error);
        }
      }
    };
    loadMenuItems();
  }, [user?.unit]);

  // Expor função de salvar para o componente pai
  useEffect(() => {
    if (onSaveClick) {
      const salvarRotina = async () => {
        // Formatar data para string no formato YYYY-MM-DD
        const formattedDate = date instanceof Date 
          ? date.toISOString().split('T')[0] 
          : typeof date === 'string' 
            ? date 
            : new Date(date).toISOString().split('T')[0];

        const newRoutine = {
          date: formattedDate,
          idSponte: String(student.AlunoID),
          breakfast: { foods: breakfast, quantity: qtdBreakfast, unavailable: unavaibleBreakfast },
          lunch: { foods: lunch, quantity: qtdLunch, unavailable: unavailableLunch },
          snack: { foods: snack, quantity: qtdSnack, unavailable: unavaibleSnack },
          cleaning: { fraud, evacuate, pee, shower: tomouBanho, wash_head: lavouCabeca, supplies: materialPessoal, info_family: infoFamilia },
          sleep: { arrive_on_time: arrivalTime, sleep_at_school: sleptSchool, entryHours, entryMinutes, exitHours, exitMinutes },
          full_uniform: { morning: morningUniform, afternoon: lateUniform },
          courseware: { full: courseware, home_work: homeWork },
          viewers: [],
          general_comments: generalComments,
        };
        
        try {
          await addRoutine(newRoutine);
          setInfoMessage("Rotina adicionada com sucesso!");
          setInfoType("success");
          setShowMessage(true);
          if (onSave) onSave();
          setTimeout(() => {
            if (onClose) onClose();
          }, 1500);
        } catch (error) {
          console.error("Erro ao salvar rotina:", error);
          setInfoMessage("Erro ao salvar rotina. Tente novamente.");
          setInfoType("error");
          setShowMessage(true);
        }
      };

      const alterarRotina = async () => {
        // Formatar data para string no formato YYYY-MM-DD
        const formattedDate = date instanceof Date 
          ? date.toISOString().split('T')[0] 
          : typeof date === 'string' 
            ? date 
            : new Date(date).toISOString().split('T')[0];

        const routine = {
          id: editData.id,
          date: formattedDate,
          idSponte: String(student.AlunoID),
          breakfast: { foods: breakfast, quantity: qtdBreakfast, unavailable: unavaibleBreakfast },
          lunch: { foods: lunch, quantity: qtdLunch, unavailable: unavailableLunch },
          snack: { foods: snack, quantity: qtdSnack, unavailable: unavaibleSnack },
          cleaning: { fraud, evacuate, pee, shower: tomouBanho, wash_head: lavouCabeca, supplies: materialPessoal, info_family: infoFamilia },
          sleep: { arrive_on_time: arrivalTime, sleep_at_school: sleptSchool, entryHours, entryMinutes, exitHours, exitMinutes },
          full_uniform: { morning: morningUniform, afternoon: lateUniform },
          courseware: { full: courseware, home_work: homeWork },
          viewers: editData.viewers || [],
          general_comments: generalComments,
        };
        
        try {
          await editRoutine(routine);
          setInfoMessage("Rotina alterada com sucesso!");
          setInfoType("success");
          setShowMessage(true);
          if (onSave) onSave();
          setTimeout(() => {
            if (onClose) onClose();
          }, 1500);
        } catch (error) {
          console.error("Erro ao alterar rotina:", error);
          setInfoMessage("Erro ao alterar rotina. Tente novamente.");
          setInfoType("error");
          setShowMessage(true);
        }
      };

      onSaveClick.current = status ? alterarRotina : salvarRotina;
    }
  }, [
    status, date, breakfast, qtdBreakfast, unavaibleBreakfast,
    lunch, qtdLunch, unavailableLunch, snack, qtdSnack, unavaibleSnack,
    tomouBanho, lavouCabeca, materialPessoal, infoFamilia,
    arrivalTime, sleptSchool, entryHours, entryMinutes, exitHours, exitMinutes,
    morningUniform, lateUniform, courseware, homeWork,
    fraud, evacuate, pee, generalComments, editData, onSave, onClose, onSaveClick
  ]);

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      {/* Tabs principais */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "13px",
              fontWeight: "600",
              minHeight: "48px",
              color: "#666",
              "&.Mui-selected": {
                color: "#1e958c",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1e958c",
            },
          }}
        >
          <Tab icon={<RestaurantIcon />} iconPosition="start" label="Alimentação" />
          <Tab icon={<CleaningServicesIcon />} iconPosition="start" label="Higiene" />
          <Tab icon={<CheckroomIcon />} iconPosition="start" label="Fardamento" />
          <Tab icon={<MenuBookIcon />} iconPosition="start" label="Material" />
          <Tab icon={<AccessTimeIcon />} iconPosition="start" label="Horários" />
          <Tab icon={<NotesIcon />} iconPosition="start" label="Observações" />
        </Tabs>
      </Box>

          {/* Conteúdo das tabs */}
          <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
            <CardsArea style={{ padding: "0 8px" }}>
            {/* Tab Alimentação */}
            {activeTab === 0 && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Foods
                  title={"Café da Manhã"}
                  foods={menu.breakfast}
                  selection={breakfast}
                  setSelection={setBreakfast}
                  qtdFood={qtdBreakfast}
                  setQtdFood={setQtdBreakfast}
                  unavailable={unavaibleBreakfast}
                  setUnavailable={setUnavailableBreakfast}
                />
                <Foods
                  title={"Almoço"}
                  foods={menu.lunch}
                  selection={lunch}
                  setSelection={setLunch}
                  qtdFood={qtdLunch}
                  setQtdFood={setQtdLunch}
                  unavailable={unavailableLunch}
                  setUnavailable={setUnavailableLunch}
                />
                <Foods
                  title={"Lanche da Tarde"}
                  foods={menu.snack}
                  selection={snack}
                  setSelection={setSnack}
                  qtdFood={qtdSnack}
                  setQtdFood={setQtdSnack}
                  unavailable={unavaibleSnack}
                  setUnavailable={setUnavailableSnack}
                />
              </Box>
            )}

        {/* Tab Higiene */}
        {activeTab === 1 && (
          <Cleaning
            title={"Higienização e Fisiológico"}
            question1={"Tomou banho na escola?"}
            option1={tomouBanho}
            setOption1={setTomouBanho}
            question2={"Lavou a Cabeça?"}
            option2={lavouCabeca}
            setOption2={setLavouCabeca}
            question3={"Material de higiene pessoal?"}
            option3={materialPessoal}
            setOption3={setMaterialPessoal}
            question4={"Família foi informada?"}
            option4={infoFamilia}
            setOption4={setInfoFamilia}
            positiveTitle={"Sim"}
            negativeTitle={"Não"}
            pee={pee}
            setPee={setPee}
            evacuate={evacuate}
            setEvacuate={setEvacuate}
            fraud={fraud}
            setFraud={setFraud}
          />
        )}

        {/* Tab Fardamento */}
        {activeTab === 2 && (
          <Form
            title={"Fardamento no Horário Integral"}
            question1={"Manhã"}
            option1={morningUniform}
            setOption1={setMorningUniform}
            question2={"Tarde"}
            option2={lateUniform}
            setOption2={setLateUniform}
            positiveTitle={"Completo"}
            negativeTitle={"Incompleto"}
          />
        )}

        {/* Tab Material */}
        {activeTab === 3 && (
          <Form
            title={"Material Didático / Pedagógico"}
            question1={"Estava com todo o material necessário?"}
            option1={courseware}
            setOption1={setCourseware}
            question2={"Atividades de casa realizadas?"}
            option2={homeWork}
            setOption2={setHomeWork}
            positiveTitle={"Sim"}
            negativeTitle={"Não"}
          />
        )}

        {/* Tab Horários */}
        {activeTab === 4 && (
          <Form
            title={"Horário de Chegada-Saída / Sono"}
            question1={"Chegou no Horário programado?"}
            option1={arrivalTime}
            setOption1={setArrivalTime}
            question2={"Dormiu na escola?"}
            option2={sleptSchool}
            setOption2={setSleptSchool}
            positiveTitle={"Sim"}
            negativeTitle={"Não"}
            sleepTime={true}
            entryHours={entryHours}
            setEntryHours={setEntryHours}
            entryMinutes={entryMinutes}
            setEntryMinutes={setEntryMinutes}
            exitHours={exitHours}
            setExitHours={setExitHours}
            exitMinutes={exitMinutes}
            setExitMinutes={setExitMinutes}
          />
        )}

        {/* Tab Observações */}
        {activeTab === 5 && (
          <AreaText>
            <Textarea
              maxRows={10}
              minRows={8}
              placeholder="Observações gerais sobre a rotina do aluno..."
              value={generalComments}
              onChange={(e) => setGeneralComments(e.target.value)}
              sx={{ width: "100%" }}
            />
          </AreaText>
            )}
            </CardsArea>
          </Box>

          <CustomAlert
        infoType={infoType}
        status={showMessage}
        setStatus={setShowMessage}
        infoMessage={infoMessage}
      />
    </Box>
  );
};

